<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "User",
  data: () => ({ user: null }),
  methods: {
    fetchCards() {
      var self = this;

      fetch("/.netlify/functions/policies")
        .then(function(response) {
          // handle success
          console.log('fetching cards')
          console.log(response.json)
          return response.json();
        })
        .then(function(data) {
          // `data` is the parsed version of the JSON returned from the above endpoint.
          console.log(data); // { "userId": 1, "id": 1, "title": "...", "body": "..." }
          self.$store.cards = data.cards;
        })
        .catch(function(error) {
          // handle error
          window.console.log(error);
        });
    },
    fetchDistrikts() {
      var self = this;
      fetch("/.netlify/functions/distrikts")
        .then(function(response) {
          // handle success
          return response.json();
        })
        .then(function(data) {
          // `data` is the parsed version of the JSON returned from the above endpoint.
          console.log(data); // { "userId": 1, "id": 1, "title": "...", "body": "..." }
          self.$store.distrikts = data.distrikts;
        })
        .catch(function(error) {
          // handle error
          window.console.log(error);
        });
    },
  },
  async created() {
    this.fetchCards();
    this.fetchDistrikts();
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;1,400&display=swap");

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
